import CrossItem from '@/components/CrossItem';
import { TableCell } from '@/components/Datatable/TableCell';
import { IDatatableData } from '@/type/listing.types';
import { FieldValues } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { Checkbox } from '@/components/Controls/Checkbox';
import { TableHeaderActions } from '@/components/Custom/Datatable/TableHeaderActions';
import { useSelectedTableItems } from '@/hooks/selected-table-items.hooks';
// import { useRowDragAnDrop } from '@/hooks/drag-and-drop.hooks';
import { TableMenu } from '@/components/Menu/TableMenu';
import { SubMenuItem } from '@/components/Menu/SubMenuItem';
import { StatusTag } from '@/components/Tag/StatusTag';
import { getTranslatedItem } from '@/utils/language.utils';
import { useUserRole } from '@/hooks/auth.hooks';

export const EquipmentTableData = <TSchema extends FieldValues>({
  t,
  data,
  pendingDeactivate,
  onDeactivate,
}: IDatatableData<TSchema>) => {
  const navigate = useNavigate();

  const { hasNoRole, isModerator } = useUserRole();

  const {
    numberOfItemsText,
    selectedTableData,
    onSelectedItem,
    handleDeactivate,
  } = useSelectedTableItems({
    t,
    data,
    onDeactivate,
  });

  // const {
  //   rowData,
  //   handleDragStart,
  //   handleDragOver,
  //   handleDragLeave,
  //   handleDrop,
  // } = useRowDragAnDrop<TSchema>(data);

  if (!data || data.length === 0) {
    return <></>;
  }

  return (
    <>
      {selectedTableData?.length > 0 && (
        <TableHeaderActions
          // colSpan={6}
          colSpan={5}
          text={numberOfItemsText}
          disableDeactivate={selectedTableData?.every((item) => !item?.active)}
          disableDownload
          onDeactivate={handleDeactivate}
          onDownload={() => {}}
          onCreate={() => navigate('/equipment/create')}
        />
      )}
      {/* {rawData.map((entry) => { */}
      {data?.map((entry) => {
        const translatedEquipment = getTranslatedItem(
          entry?.translatedEquipments,
        );

        return (
          <tr
            key={entry?.id}
            className={twMerge('', !entry?.active && 'tr-deactivated')}
            // draggable
            // style={{ cursor: 'grab' }}
            // onDragStart={(event) => handleDragStart(event, entry)}
            // onDragOver={handleDragOver}
            // onDragLeave={handleDragLeave}
            // onDrop={(event) => handleDrop(event, entry)}
          >
            {!hasNoRole && !isModerator && (
              <TableCell
                tdClassName="sticky-select-column"
                content={
                  <Checkbox
                    checked={Boolean(
                      selectedTableData?.find((item) => item?.id === entry?.id),
                    )}
                    onChange={() => onSelectedItem(entry?.id)}
                  />
                }
              />
            )}
            {/* <TableCell
              tdClassName="text-center"
              content={
                <div className="inline-flex justify-center items-center w-8 min-w-8 h-8 min-h-8 bg-slate-100 rounded-md hover:cursor-grab">
                  <i className="ki-outline ki-arrow-two-diagonals text-lg" />
                </div>
              }
            /> */}
            <TableCell content={translatedEquipment?.name || entry?.name} />
            <TableCell
              content={<CrossItem isSuccess={entry?.isMultiple || false} />}
            />
            <TableCell
              tdClassName="text-center"
              content={
                <StatusTag
                  text={`${
                    entry?.active ? t('common:active') : t('common:inactive')
                  }`}
                  className={twMerge(
                    'pt-[6px] pb-[5px] text-[10.1px] font-semibold [word-spacing:1.9px] leading-snug uppercase',
                    entry?.active &&
                      'bg-green-EAFFF2 border-green-C9F4D2 text-green-11BFA4',
                    !entry?.active &&
                      'bg-red-FFEEF4 border-red-FFCAD6 text-red-FF3680',
                  )}
                />
              }
            />
            <TableCell
              tdClassName="sticky-action-column"
              content={
                <TableMenu>
                  <SubMenuItem
                    text={t('common:edit')}
                    leftIconClassName="ki-notepad-edit !text-[16px]"
                    to={`/equipment/edit/${entry?.id}`}
                  />
                  {!hasNoRole && !isModerator && (
                    <SubMenuItem
                      text={t('common:deactivate')}
                      disabled={!entry?.active || pendingDeactivate}
                      leftIconClassName="ki-trash !text-[19px]"
                      textClassName="line-clamp-1"
                      onClick={() => onDeactivate([entry])}
                    />
                  )}
                </TableMenu>
              }
            />
          </tr>
        );
      })}
    </>
  );
};
